document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-fc-vrks-sub-collections]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const list = section.querySelector('.fc-vrks-sub-collections__list');
    const underline = section.querySelector('.fc-vrks-sub-collections__underline');
    const activeItem = section.querySelector('.fc-vrks-sub-collections__item.is-active');

    if (!list || !underline || !activeItem) return;

    function updateUnderline(item) {
      const itemRect = item.getBoundingClientRect();
      const listRect = list.getBoundingClientRect();

      underline.style.width = `${itemRect.width}px`;
      underline.style.transform = `translateX(${itemRect.left - listRect.left + list.scrollLeft}px)`;
    }

    function scrollActiveIntoView() {
      if (window.innerWidth >= 750) return;

      activeItem.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }

    // Initial state
    updateUnderline(activeItem);
    scrollActiveIntoView();

    // Hover animation
    list.querySelectorAll('.fc-vrks-sub-collections__item').forEach((item) => {
      item.addEventListener('mouseenter', () => {
        updateUnderline(item);
      });

      item.addEventListener('mouseleave', () => {
        updateUnderline(activeItem);
      });
    });

    // Window resize
    window.addEventListener('resize', () => {
      updateUnderline(activeItem);
    });

    // Mobile scroll
    list.addEventListener('scroll', () => {
      updateUnderline(activeItem);
    });
  });
});